import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { reprintCertificateType } from "../../store/reprintCertifacatesQuote/actions";
export var useReprintCertificate = function (trigger, quoteId, type, onResetTrigger) {
    if (trigger === void 0) { trigger = false; }
    if (quoteId === void 0) { quoteId = ""; }
    if (type === void 0) { type = "QUICK_PRINT"; }
    var dispatch = useDispatch();
    var validQuoteId = (quoteId !== null && quoteId !== void 0 ? quoteId : "").trim();
    var _a = useSelector(function (state) { return ({
        loadingReprintType: state.Reprint.loadingReprintType,
        responseReprintType: state.Reprint.responseReprintType,
        errorReprintType: state.Reprint.errorReprintType,
    }); }), loadingReprintType = _a.loadingReprintType, responseReprintType = _a.responseReprintType, errorReprintType = _a.errorReprintType;
    useEffect(function () {
        if (!trigger || !validQuoteId)
            return;
        dispatch(reprintCertificateType({
            id: quoteId,
            type: type,
        }));
        if (onResetTrigger)
            onResetTrigger();
    }, [trigger, dispatch, quoteId, type]);
    return {
        loadingReprintType: loadingReprintType,
        responseReprintType: responseReprintType,
        errorReprintType: errorReprintType,
    };
};
//Plan anual   /  RD$86,330.00
